export default function PageHeader({ eyebrow, title, description }) {
  return (
    <section className="relative isolate overflow-hidden border-b border-neutral-200/80 bg-white">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_18%_0%,rgba(37,99,235,0.12),transparent_28rem),radial-gradient(circle_at_88%_10%,rgba(6,182,212,0.10),transparent_24rem)]" />
      <div className="site-shell py-12 sm:py-16 lg:py-20">
        {eyebrow && <p className="eyebrow-chip">{eyebrow}</p>}
        <h1 className="mt-5 max-w-5xl text-4xl font-black tracking-tight text-neutral-950 sm:text-5xl lg:text-6xl">{title}</h1>
        {description && <p className="mt-5 max-w-4xl text-lg leading-8 text-neutral-700">{description}</p>}
      </div>
    </section>
  );
}
